import { render, staticRenderFns } from "./MyOrderDetails.vue?vue&type=template&id=364bc21c&"
import script from "./MyOrderDetails.vue?vue&type=script&lang=js&"
export * from "./MyOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports